import React from 'react';
import { LeadSourceHealth } from '../types/leads';
import { ArrowRightIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
interface SourceHealthGridProps {
  sourceHealth: LeadSourceHealth[];
  activeSourceFilter: string | null;
  onSourceClick: (source: string) => void;
}
export function SourceHealthGrid({
  sourceHealth,
  activeSourceFilter,
  onSourceClick
}: SourceHealthGridProps) {
  return <div className="space-y-4" data-id="element-249">
      <div className="flex items-center justify-between" data-id="element-250">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-251">
          Routing Health by Lead Source
        </h2>
        {activeSourceFilter && <button onClick={() => onSourceClick(activeSourceFilter)} className="text-sm text-blue-600 hover:text-blue-800 font-medium" data-id="element-252">
            Clear Filter
          </button>}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-id="element-253">
        {sourceHealth.map(source => {
        const totalRouted = source.routedCount + source.resolvedCount;
        const totalIssues = source.missingCount + source.errorCount + source.pendingCount;
        const isPerfect = totalIssues === 0 && source.totalToday > 0;
        const hasIssues = totalIssues > 0;
        const percentRouted = source.totalToday > 0 ? Math.round(totalRouted / source.totalToday * 100) : 0;
        const isActive = activeSourceFilter === source.name;
        return <button key={source.name} onClick={() => onSourceClick(source.name)} className={`
                text-left w-full bg-white rounded-xl p-4 transition-all duration-200 border
                ${isActive ? 'ring-2 ring-blue-500 border-blue-500 shadow-md scale-[1.02]' : 'border-gray-200 shadow-sm hover:shadow-md hover:border-gray-300'}
                ${isPerfect && !isActive ? 'border-l-4 border-l-green-400' : ''}
                ${hasIssues && !isActive ? 'border-l-4 border-l-red-400' : ''}
              `} aria-pressed={isActive} data-id="element-254">
              <div className="flex justify-between items-start mb-2" data-id="element-255">
                <div data-id="element-256">
                  <h3 className="font-semibold text-gray-900 truncate" data-id="element-257">
                    {source.name}
                  </h3>
                  <div className="flex items-center text-xs text-gray-500 mt-0.5" data-id="element-258">
                    <ArrowRightIcon className="h-3 w-3 mr-1" data-id="element-259" />
                    <span className="truncate max-w-[120px]" title={source.expectedDialingList} data-id="element-260">
                      {source.expectedDialingList}
                    </span>
                  </div>
                </div>
                {isPerfect ? <CheckCircleIcon className="h-5 w-5 text-green-500 flex-shrink-0" data-id="element-261" /> : hasIssues ? <AlertCircleIcon className="h-5 w-5 text-red-500 flex-shrink-0" data-id="element-262" /> : null}
              </div>

              <div className="mt-4 flex justify-between text-sm mb-1" data-id="element-263">
                <span className="text-gray-600" data-id="element-264">
                  <span className="font-medium text-gray-900" data-id="element-265">
                    {totalRouted}
                  </span>{' '}
                  routed
                </span>
                {hasIssues && <span className="text-red-600 font-medium" data-id="element-266">
                    {totalIssues} missing
                  </span>}
              </div>

              <div className="w-full bg-gray-100 rounded-full h-1.5 mt-2 flex overflow-hidden" data-id="element-267">
                <div className="bg-green-500 h-1.5 rounded-l-full" style={{
              width: `${percentRouted}%`
            }} data-id="element-268" />
                {hasIssues && <div className="bg-red-400 h-1.5 rounded-r-full" style={{
              width: `${100 - percentRouted}%`
            }} data-id="element-269" />}
              </div>
            </button>;
      })}
      </div>
    </div>;
}